import { HomeExamTable } from './HomeExamTable';
export default HomeExamTable;
